import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import LoginView from "./views/LoginView.vue";
import HomeView from "./views/HomeView.vue";
import JobDetailView from "./views/JobDetailView.vue";
import NewJobForm from "./views/NewJobForm.vue";
import { useAuth } from "./composables/useAuth";

const routes: RouteRecordRaw[] = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { public: true },
  },
  { path: "/", name: "home", component: HomeView },
  { path: "/new", name: "new-job", component: NewJobForm },
  { path: "/jobs/:id", name: "job-detail", component: JobDetailView, props: true },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

/**
 * Auth gate. Runs before every navigation:
 *  - Wait for the first /api/auth/me probe to complete (`ready`) before
 *    deciding; otherwise the first navigation races the auth check and
 *    bounces an authenticated user to /login.
 *  - Public routes (the login screen) skip the check.
 *  - Unauthenticated users on private routes go to /login.
 *  - Authenticated users hitting /login go home (avoids a stuck login
 *    screen after sign-in completes).
 */
router.beforeEach(async (to) => {
  const auth = useAuth();
  if (!auth.ready.value) {
    await auth.refresh();
  }
  const isPublic = to.meta.public === true;
  if (!isPublic && !auth.isAuthenticated.value) {
    return { name: "login", query: { next: to.fullPath } };
  }
  if (to.name === "login" && auth.isAuthenticated.value) {
    return { name: "home" };
  }
  return true;
});
